var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoayudaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Autoayuda_White",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.402,
    height: 105.891,
    viewBox: "0 0 95.402 105.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbfaf1;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    className: "cls-1",
    width: 95.402,
    height: 105.891
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    className: "cls-1",
    d: "M83.673,105.891a10.92,10.92,0,0,1-4.92-1.05,10.255,10.255,0,0,1-3.492-2.83,22.59,22.59,0,0,1-2.714-4.87c-.881-2.009-1.644-3.8-2.27-5.319l-.02-.049-4.221-11.1H28.7L24.477,92.029c-1.924,5.161-3.553,8.591-4.981,10.485-1.69,2.241-4.371,3.377-7.969,3.377a11.322,11.322,0,0,1-8.023-3.3A10.379,10.379,0,0,1,0,94.9a15.98,15.98,0,0,1,.763-4.759c.462-1.48,1.227-3.544,2.273-6.135L8.264,70.733a1.98,1.98,0,0,1,3.685,1.451L6.714,85.474c-1.012,2.507-1.74,4.469-2.171,5.848A12.041,12.041,0,0,0,3.96,94.9a6.49,6.49,0,0,0,2.277,4.82,7.391,7.391,0,0,0,5.291,2.21c2.321,0,3.893-.589,4.806-1.8.809-1.074,2.235-3.592,4.432-9.484l5.186-13.929H68.767L73.949,90.34c.613,1.488,1.361,3.242,2.225,5.212a19.278,19.278,0,0,0,2.193,4,6.244,6.244,0,0,0,2.158,1.744,7.039,7.039,0,0,0,3.148.631,7.424,7.424,0,0,0,5.492-2.278,6.786,6.786,0,0,0,2.277-4.886c0-1.322-.5-4.095-2.873-9.795l-.008-.018L62.8,21.328l-.007-.02c-1.186-3.119-2.186-5.67-2.973-7.582a26.715,26.715,0,0,0-2.69-4.975,11.491,11.491,0,0,0-3.85-3.469A12.107,12.107,0,0,0,47.3,3.96a11.946,11.946,0,0,0-5.916,1.323A11.062,11.062,0,0,0,37.545,8.8a31.742,31.742,0,0,0-3.027,6.039l-.044.111q-1.481,3.787-2.54,6.5L18.238,57.83a1.98,1.98,0,0,1-3.706-1.4L28.24,20.02Q29.3,17.3,30.786,13.507l.044-.112a35.628,35.628,0,0,1,3.427-6.8A15.139,15.139,0,0,1,39.43,1.837,15.809,15.809,0,0,1,47.3,0a15.964,15.964,0,0,1,7.934,1.837A15.421,15.421,0,0,1,60.392,6.5a30.719,30.719,0,0,1,3.092,5.715c.8,1.942,1.809,4.519,3,7.662l25.74,63.576c2.136,5.128,3.174,8.828,3.174,11.309a10.684,10.684,0,0,1-3.437,7.687,11.353,11.353,0,0,1-8.292,3.437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    className: "cls-1",
    d: "M186.15,157.035h-27.23a2.758,2.758,0,0,1-2.6-3.69l13.491-37.613A2.731,2.731,0,0,1,172.4,113.9h.009A2.731,2.731,0,0,1,175,115.717l13.739,37.613a2.758,2.758,0,0,1-2.591,3.705m-25.523-3.96h23.8l-12.011-32.881Z",
    transform: "translate(-125.24 -91.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    className: "cls-1",
    d: "M58.725,316.638a1.982,1.982,0,0,1-1.87-2.633l.332-.953a1.98,1.98,0,1,1,3.739,1.3l-.332.953a1.981,1.981,0,0,1-1.87,1.329",
    transform: "translate(-45.508 -250.001)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoayudaWhite);
export default __webpack_public_path__ + "static/media/Autoayuda_White.b4d78a5e464cc95e788898881b6390bb.svg";
export { ForwardRef as ReactComponent };